// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"164":"9d7e4bfb","270":"20d1b10a","672":"55ec8116","787":"ca6d26d4","815":"20fc8bf3","935":"e5625996","952":"b729e36b","987":"eb4db9f2"}[chunkId] + ".css";
};